// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1vzeP","title":"ClientCherryInfo_title__1_Kck","itemText":"ClientCherryInfo_itemText__wu3Dw"};